@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .root {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 400px;
    border-left: 1px solid var(--border-soft);
    background-color: var(--background-default);
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    height: 72px;
    padding: 0 16px;
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
  }

  .headerContent {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }

  .title {
    @include typography-v2-title-sm;
    color: var(--text-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .closeButton {
    flex-shrink: 0;
  }

  .body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: relative;
  }
}
